export const CURRENCIES = ['USD', 'EUR'];
